export async function initialize() {
	return fetch('https://api.ipregistry.co/?key=tryout')
	.then(res => res.json())
	.then(res => {
		currency = res.currency.code;
		
		if (currency != 'USD' || currency != 'SAR') {
			currency = 'usd'
		}

		updateTable(currency)
	})
	.catch(() => {
		updateTable('usd')
	})
}

/**
 * Updates the prices of the packages as well as check for currency via user geography.
 * Also adds click listeners to update prices based on choice of subscription.
 */
export function updateTable(currency) {
	updatePrices(currency);
	updateTableRows()
}

/**
 * Updates the pricing based on the provided type as well as currrency.
 * Available currencies: usd, sar
 * @param {String} currency 
 */
function updatePrices(currency) {
	const sale = packages.dataset.sale;

	packages.querySelectorAll('.package_price').forEach(elm => {
		let price = elm.dataset[currency];
		let updated_price = price - (price * sale/100);

		Array.from(elm.attributes).forEach(attr => {
			if (attr.name != 'class') { 
				elm.removeAttribute(attr.name)
			}
		});

		elm.children[0].innerHTML = `${updated_price.toLocaleString('en-US')} ${currency.toUpperCase()}`;
		elm.children[1].children[1].innerText = `${Number(price).toLocaleString('en-US')} ${currency.toUpperCase()}`
	})
}

/**
 * Responsible for updating the rows that requires data handling.
 */
function updateTableRows() {
	packages.querySelectorAll('.package_subcategory [data-value]').forEach(elm => {
		if (elm.dataset.value == 'true') {
			elm.innerHTML = `<img src="/assets/media/icons/check.svg" alt="check">`
		} else if (elm.dataset.value == 'false') {
			elm.innerHTML = `<img src="/assets/media/icons/xmark.svg" alt="xmark">`
		} else {
			elm.innerText = elm.dataset.value
		}
		
		elm.removeAttribute('data-value')
	})
}